import { bl_svc_issue_request_hdr_RowClass } from '../../../dbschema/bl_svc_issue_request_hdr.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceNoteIssueRequestHdrContainerModel extends BaseContainerModel {
  bl_svc_issue_request_hdr: bl_svc_issue_request_hdr_RowClass = new bl_svc_issue_request_hdr_RowClass();
}
